<template>
  <canvas-page :terminal="4" :typeId="1"></canvas-page>
</template>

<script>
  import CanvasPage from '../../components/canvasShow/canvasShowPage'
  export default {
    name: 'index',
    components: { CanvasPage },
    data () {
      return {
        canvasData: []
      }
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/home/index.vue